
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  JieLongStatus,
  JIELONG_STATUS as JIELONG_STATUS_MAP,
  endJielong,
  cancelJielong,
} from "@/api/jielong";
import TipsPopup from "@/components/tipsPopup/index.vue";
import { Getter } from "vuex-class";

@Component({ components: { TipsPopup } })
export default class PreviewFooter extends Vue {
  @Prop({ type: Boolean, default: false }) isDetailMode!: boolean;
  @Prop({ type: Number, default: JIELONG_STATUS_MAP.NOT_STARTED }) status!: JieLongStatus;
  @Prop({ type: String, default: "" }) joinActivityId!: string;
  @Prop({ type: Boolean, default: false }) submitLoading!: boolean;
  @Prop({ type: String, default: "立即发起" }) submitText!: string;
  @Prop({ type: String, default: "/newJielong" }) editRoute!: string;
  @Prop({ type: String, default: "/jielongOrder" }) orderRoute!: string;

  confirmTitle = "";
  confirmContent = "";
  confirmOkText = "";
  private pendingAction: "end" | "cancel" | null = null;

  @Getter companyId!: string;

  JIELONG_STATUS = JIELONG_STATUS_MAP;

  onEdit (): void {
    if (!this.joinActivityId) return;
    this.$router.push({
      path: this.editRoute,
      query: { id: this.joinActivityId },
    });
  }

  onOrder (): void {
    if (!this.joinActivityId) return;
    this.$router.push({
      path: this.orderRoute,
      query: { id: this.joinActivityId },
    });
  }

  onShare (): void {
    this.$emit("share");
  }

  onCancel (): void {
    this.pendingAction = "cancel";
    this.confirmTitle = "提示";
    this.confirmContent = "确认取消该接龙？";
    this.confirmOkText = "确认";
    (this.$refs.confirmPopup as any).showPopup();
  }

  onEnd (): void {
    this.pendingAction = "end";
    this.confirmTitle = "提示";
    this.confirmContent = "确认提前结束该接龙？";
    this.confirmOkText = "确认";
    (this.$refs.confirmPopup as any).showPopup();
  }

  onConfirmAction (): void {
    if (!this.joinActivityId) {
      this.pendingAction = null;
      return;
    }
    if (this.pendingAction === "end") {
      endJielong({ joinActivityList: [{ joinActivityId: this.joinActivityId }], storeId: this.companyId })
        .then(() => {
          this.$toast("已结束接龙");
          this.$emit("refresh");
        })
        .catch(() => {
          this.$toast("结束失败，请重试");
        });
    } else if (this.pendingAction === "cancel") {
      cancelJielong({ joinActivityList: [{ joinActivityId: this.joinActivityId }], storeId: this.companyId })
        .then(() => {
          this.$toast("已取消接龙");
          this.$emit("refresh");
        })
        .catch(() => {
          this.$toast("取消失败，请重试");
        });
    }
    this.pendingAction = null;
  }
}
